import { createSvg } from '@r1-frontend/ui-react/components/svg/createSvg';

const Menu = (
    {
        strokeWidth = 1.5,

    },
): JSX.Element => {
    return (
        <g id={'guts'} >
            <path d='M3 7H21' strokeWidth={strokeWidth} strokeLinecap='round'/>
            <path d='M3 12H21' strokeWidth={strokeWidth} strokeLinecap='round'/>
            <path d='M3 17H21' strokeWidth={strokeWidth} strokeLinecap='round'/>
        </g>
    );
};

export default createSvg(
    Menu,
    'close',
);
